module.exports = __webpack_public_path__ + "static/media/image-8.fcbc7f61.jpg";